import { useEffect, useState } from 'react';
import { useShouldSeeChangeDefaultHomepageModal } from '../hooks/modal';
import { Redirect, useHistory, useRouteMatch } from 'react-router-dom';
import { CHANGE_DEFAULT_HOMEPAGE_ROUTE } from '../constants/routeConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export const CheckDefaultHomepageRedirect = () => {
  // Check if we should redirect to the default homepage chooser
  const history = useHistory();
  const routeInfo = useRouteMatch('/');
  const isOnHomepage = routeInfo && routeInfo.isExact;
  const {
    shouldSeeModal: shouldSeeChangeDefaultModal
  } = useShouldSeeChangeDefaultHomepageModal();
  const [hasSeenChangeDefaultHomepageModal, setHasSeenChangeDefaultHomepageModal] = useState(false);
  useEffect(() => {
    if (shouldSeeChangeDefaultModal) {
      setHasSeenChangeDefaultHomepageModal(true);
    }
  }, [shouldSeeChangeDefaultModal]);
  const state = history.location.state || {};
  if (!isOnHomepage || state.redirectedFromChangeDefaultHomepageModal || !shouldSeeChangeDefaultModal || hasSeenChangeDefaultHomepageModal) {
    return null;
  }
  return /*#__PURE__*/_jsx(Redirect, {
    to: `${CHANGE_DEFAULT_HOMEPAGE_ROUTE}?persistClose=true&homepageModalLang=app`
  });
};